import { NavLink } from "react-router-dom";
import { Compass, Library, ListMusic, LogOut, Sparkles, UserRound, Users, Wand2 } from "lucide-react";
import { Avatar } from "./Avatar";
import { NotificationBell } from "./NotificationBell";
import { useAuth } from "../context/AuthContext";

const links = [
  { to: "/", label: "Kurti", icon: Wand2, id: "create" },
  { to: "/atrasti", label: "Atrasti", icon: Compass, id: "discover" },
  { to: "/biblioteka", label: "Biblioteka", icon: Library, id: "library" },
  { to: "/grojarasciai", label: "Grojaraščiai", icon: ListMusic, id: "playlists" },
  { to: "/sekami", label: "Sekami", icon: Users, id: "following" },
];

const UserBox = () => {
  const { user, logout } = useAuth();
  return (
    <div data-testid="user-box" className="mt-auto mx-4 p-3 rounded-2xl border border-[var(--c-line)] bg-[var(--c-surface)] flex items-center gap-3">
      <NavLink to="/profilis" data-testid="nav-profile" title="Profilis" className="flex items-center gap-3 min-w-0 flex-1 group">
        <Avatar user={user} />
        <div className="min-w-0 flex-1">
          <p data-testid="user-name" className="text-sm font-semibold truncate group-hover:text-[var(--c-orange)] transition-colors">{user.name}</p>
          <p className="text-[11px] text-zinc-500 truncate">{user.email}</p>
        </div>
      </NavLink>
      <button data-testid="logout-button" onClick={logout} title="Atsijungti" className="p-2 rounded-lg text-zinc-400 hover:text-white hover:bg-[var(--c-hover)] transition-colors">
        <LogOut className="w-4 h-4" />
      </button>
    </div>
  );
};

export const MobileLogout = () => {
  const { logout } = useAuth();
  return (
    <button data-testid="mobile-logout-button" onClick={logout} className="flex flex-col items-center text-[10px] gap-0.5 px-1 py-1 text-zinc-400">
      <LogOut className="w-5 h-5" />Atsijungti
    </button>
  );
};

export const Sidebar = () => (
  <aside className="hidden md:flex w-60 shrink-0 flex-col border-r border-[var(--c-line)] bg-[var(--c-bg)] sticky top-0 h-screen pb-28">
    <div className="px-6 pt-7 pb-8">
      <div className="flex items-center gap-2" data-testid="brand-logo">
        <div className="w-9 h-9 rounded-xl bg-[var(--c-orange)] flex items-center justify-center glow-orange">
          <Sparkles className="w-5 h-5 text-white" />
        </div>
        <span className="font-display font-bold text-lg">Dainuok<span className="text-[var(--c-orange)]">.ai</span></span>
        <div className="ml-auto -mr-2"><NotificationBell /></div>
      </div>
      <div className="flag-line h-[3px] w-16 mt-4 rounded-full" />
    </div>
    <nav className="flex flex-col gap-1 px-3">
      {links.map(({ to, label, icon: Icon, id }) => (
        <NavLink key={to} to={to} end data-testid={`nav-${id}`}
          className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-colors duration-200 ${
            isActive ? "bg-[var(--c-elev)] text-white" : "text-zinc-400 hover:text-white hover:bg-[var(--c-surface)]"}`}>
          <Icon className="w-4 h-4" />{label}
        </NavLink>
      ))}
    </nav>
    <UserBox />
  </aside>
);

export const MobileNav = () => (
  <nav className="md:hidden fixed top-0 inset-x-0 z-40 flex justify-around bg-[var(--c-bg)]/90 backdrop-blur-xl border-b border-[var(--c-line)] py-2">
    {links.map(({ to, label, icon: Icon, id }) => (
      <NavLink key={to} to={to} end data-testid={`mobile-nav-${id}`}
        className={({ isActive }) => `flex flex-col items-center text-[10px] gap-0.5 px-1 py-1 ${isActive ? "text-[var(--c-orange)]" : "text-zinc-400"}`}>
        <Icon className="w-5 h-5" />{label}
      </NavLink>
    ))}
    <NavLink to="/profilis" data-testid="mobile-nav-profile"
      className={({ isActive }) => `flex flex-col items-center text-[10px] gap-0.5 px-1 py-1 ${isActive ? "text-[var(--c-orange)]" : "text-zinc-400"}`}>
      <UserRound className="w-5 h-5" />Profilis
    </NavLink>
    <NotificationBell testId="mobile-notification-bell" align="end" />
    <MobileLogout />
  </nav>
);
